// extracted by mini-css-extract-plugin
export default {"item":"NavItem_item__Oxny3","labeled":"NavItem_labeled__JmX3u","label":"NavItem_label__g14vN","iconWrapper":"NavItem_iconWrapper__eCDS8","active":"NavItem_active__Q6DhO"};